import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useFeature from 'hooks/useFeature';

import { selectTenant, FeatureGroups } from 'state/tenant';

const useStartPageName = () => {
  const { isGroupEnabled } = useFeature();
  const { isEnabled } = useFeature();
  const {
    enabledFeatures: { cardChoices, productChoices },
  } = useSelector(selectTenant);

  const startRoute = useMemo(() => {
    const hasCardChoice = cardChoices.length > 0;

    const hasProductChoice = productChoices.length > 0;
    const hasConsumerSearch = isGroupEnabled(FeatureGroups['consumer-search']);

    if (isEnabled('cardSelector')) {
      return 'card-selector';
    } else if (hasProductChoice) {
      return 'product-choice';
    } else if (hasCardChoice) {
      return 'card-choice';
    } else if (hasConsumerSearch) {
      return 'consumer-search';
    } else {
      return 'credit-application';
    }
  }, [cardChoices.length, isGroupEnabled, productChoices.length, isEnabled]);

  return startRoute;
};

export default useStartPageName;
